<template>
  <expert-layout>
    <v-layout wrap>
      <v-flex xs12 sm12 class="mx-3 mb-2">
        <v-toolbar dense flat color="toolbarColor">Job Details</v-toolbar>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="list-section mx-3 mt-2 pa-3">
      <v-flex xs12 sm12>
        <v-toolbar flat color="toolbarColor">
          <v-toolbar-title class="title">Title: {{job.title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="text-xs-right mr-2" v-if="job.is_vip_featured == true">
            <v-chip color="orange" dark small><v-icon color="white"></v-icon>Featured</v-chip>
          </div>
          <v-btn @click="back" color="btnColor" right flat>Back</v-btn>
        </v-toolbar>
      </v-flex>

      <v-flex xs12 sm12>        
        <p class="font-weight-bold">Description: <div v-html="job.description"></div></p>
      </v-flex>
      <v-flex xs12 sm12>
        <h4 v-if="job.location">Primary Job Location: <span class="font-weight-regular">{{job.location.locationName}}</span></h4>
      </v-flex>
      <v-flex xs12 sm12 v-if="job.is_vip_featured == true && (job.userId.locationOne || job.userId.locationTwo || job.userId.locationThree || job.userId.locationForu)">
        <h4><strong>Additional Preferred Expert Locations: </strong> <span class="font-weight-regular" v-if="job.userId.locationOne">
          {{job.userId.locationOne.locationName}}</span>
          <span class="font-weight-regular" v-if="job.userId.locationTwo">
          : {{job.userId.locationTwo.locationName}}</span>
          <span class="font-weight-regular" v-if="job.userId.locationThree">
          : {{job.userId.locationThree.locationName}}</span>
          <span class="font-weight-regular" v-if="job.userId.locationFour">
          : {{job.userId.locationFour.locationName}}</span>
        </h4>
      </v-flex>
      <v-flex xs12 sm12 v-if="job.active == true && job.assigned == false && job.expired == false">
        <h4>Job Status: <span class="jobStatus">Available</span></h4>
      </v-flex>
      <v-flex xs12 sm12>
        <h4>Category: <span class="font-weight-regular">{{job.category}} {{job.subcategory}}</span></h4>
      </v-flex>
      <v-flex xs12 sm12>
        <h4>Timeframe: <span class="font-weight-regular">{{job.timeFrame}}</span></h4>
      </v-flex>
      <v-flex xs12 sm12>
        <h4>Posted On: <span class="font-weight-regular">{{job.createdAt | moment("DD MMMM YYYY") }}</span></h4>
      </v-flex>
      <v-flex xs12 sm12>
        <hr>
        <label>Images</label>
      </v-flex>
      <v-flex xs12 sm4 v-for="(image, index) in job.images" v-bind:key="index" class="pa-1">
        <v-img
          v-if="image"
          :src="`${host}/uploads/jobs/${image}`"
          @click="openGallery(index)" alt="thumbnail" title="Click to view"
        ></v-img>
      </v-flex>
      <LightBox
        v-if="job.images && job.images.length > 0"
        ref="lightbox"
        :media="media"
        :show-caption="false"
        :show-light-box="false"
      />
      <v-flex xs12 sm12>
        <v-btn
         v-if="job.active == true && job.assigned == false && job.bidStatus == false && job.expired == false" 
          flat
          color="engageColor"
          outline
          round
          class="right"
          :loading="loader"
          @click="engageSonko(job)"
        >Bid Job</v-btn>
         <span v-if="job.status == 'expired' || job.expired == true" style="color: red" class="right">Expired</span>
         <span v-else-if="job.active == true && job.assigned == true" style="color: red" class="right">Assigned</span>
         <span v-else-if="job.active == false" style="color: red" class="right">Job Unavailable</span>
         <span v-else-if="job.bidStatus == true" style="color: green" class="right">
          Bid Submitted
        </span>
         <br>
          <!-- <span v-if="job.bidStatus == true" style="color: green" class="right">Bid Submitted</span> -->
      </v-flex>

      <!-- notofication  -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-toolbar color="blue darken-2" flat dense dark>
            <v-toolbar-title class="title">Bid Successful</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click="close">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>Your bid has been submitted. The sonko will contact you.</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of notification -->

      <!-- image modal -->
      <v-dialog v-model="imageDialog" max-width="1200px">
        <v-card>
          <v-toolbar flat dense color="light-blue" dark>
            <v-toolbar-title class="title">Image preview</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="mb-2" @click.native="closeImage">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <img class="modal-img" :src="`${host}/uploads/jobs/${currentImage}`">
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of image modal -->

    </v-layout>
  </expert-layout>
</template>

<script>
import { mapGetters } from "vuex";
import LightBox from 'vue-image-lightbox'
export default {
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  components: {LightBox},
  data() {
    return {
      job: {},
      dialog: false,
      loader: false,
      imageDialog: false,
      currentImage: null,
      media: [],
    };
  },
  methods: {
    showImage(img) {
      this.currentImage = img;
      this.imageDialog = true;
    },
    closeImage() {
      this.imageDialog = false;
    },
    back() {
      this.$router.push("/expert/landing");
    },
    engageSonko(job) {
      const data = {
        sonko: job.userId,
        jobId: job._id,
        userId: this.user._id
      };
      // send request
      this.loader = true;
      const self = this;
      const res = this.$store
        .dispatch("post", { url: "/engagement", data })
        .then(res => {})
        .finally(() => {
          self.loader = false;
          self.dialog = true;
          location.reload();
        });
      // end
    },
    close() {
      this.dialog = false;
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index)
    },
  },
  created() {
    const id = this.$route.params.id;
    const jobUser = this.user;
   const userId = jobUser._id;
    if (id !== undefined) {
      this.$store.dispatch("get", "/job/user/" + id + "/" + userId ).then(res => {
        this.job = res.job;
        this.job.images.forEach(image => {
          this.media.push({
              thumb: `${this.host}/uploads/jobs/${image}`,
              src: `${this.host}/uploads/jobs/${image}`,
            })
        });
      });
    }
  }
};
</script>
<style type="text/css">
  .jobStatus {
    color: #008000;
  }
</style>
